import React, { CSSProperties } from 'react'
import theme from '@/theme'

// @ts-ignore
import Bubble from '@/components/atoms/Bubble'
import Helmet from '@/components/molecules/Helmet'
import { withPrefix } from 'gatsby-link'

// Amplifyのauthenticatorの影響でstyled-componentは使えない…
const flexCenter: CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}

const styles: { [key: string]: CSSProperties } = {
    accWrapper: {
        fontFamily: theme.typography.fontFamily,
    },
    bubble: {
        maxWidth: '450px',
        margin: 'auto',
        padding: '50px 100px',
    },
    content: {
        ...flexCenter,
    },
    subTitle: {
        color: `${theme.colors.black}`,
        fontSize: 28,
        fontWeight: 500,
        marginBottom: '30px',
    },
    logoWrapper: {
        ...flexCenter,
        padding: 60,
    },
}

export default function (props: { subtitile: string; children: React.ReactNode }) {
    return (
        <div style={styles.accWrapper}>
            <Helmet />
            <div style={styles.logoWrapper}>
                <img src={withPrefix('/assets/logo/logo-new.png')} width={400} />
            </div>
            <Bubble style={styles.bubble}>
                <div style={styles.subTitle}>{props.subtitile}</div>
                <div style={styles.content}>{props.children}</div>
            </Bubble>
        </div>
    )
}
